export const hackLangLength = (lang) => {
  if (lang === 'de') {
    return { transform: 'scale(0.7)' };
  } else if (lang === 'fr' || lang === 'ja') {
    return { transform: 'scale(0.8)' };
  }
  return {};
};
